export const setVendorsReducer = (state, action) => {
    state.vendors = action.payload;
};

export const addVendorReducer = (state, action) => {
    state.vendors[action.payload.id] = action.payload;
};

export const removeVendorReducer = (state, action) => {
    delete state.vendors[action.payload];
};

export const updateVendorReducer = (state, action) => {
    const updated = action.payload;
    if (state.vendors[updated.id]) {
        state.vendors[updated.id] = { ...state.vendors[updated.id], ...updated };
    }
};

export const setCurrentVendorReducer = (state, action) => {
    state.currentVendor = action.payload;
};
